import { APP_SCHEME, APP_SUBDOMAIN, isLocalhost } from "../utils/constants";
import { getEventUrl } from "../utils/helpers";

export const useWebsiteButton = () => {
  const goToLogin = () => {
    window.location.href = isLocalhost
      ? "/login"
      : `${APP_SCHEME}//${APP_SUBDOMAIN}/login`;
  };

  const goToSignup = () => {
    window.location.href = isLocalhost
      ? "/signup"
      : `${APP_SCHEME}//${APP_SUBDOMAIN}/signup`;
  };

  const goToProfile = () => {
    window.location.href = isLocalhost
      ? "/settings"
      : `${APP_SCHEME}//${APP_SUBDOMAIN}/settings`;
  };

  const goToDashboard = () => {
    window.location.href = isLocalhost
      ? "/home"
      : `${APP_SCHEME}//${APP_SUBDOMAIN}/home`;
  };

  const goToEvent = (slug: string) => {
    // return isLocalhost ? url : `${APP_SCHEME}//${APP_SUBDOMAIN}${url}`;
    return getEventUrl(slug);
  };

  return { goToLogin, goToSignup, goToProfile, goToDashboard, goToEvent };
};
